import { getCartCount, getCartOrders, getOrderById, getDeleteCartOrder, setDeleteCartOrder } from "./OrderAction";

const dispatchGetOrderById = (dispatch: Function) => (val : any) => {
    dispatch(getOrderById(val));
};

const dispatchGetCartCount = (dispatch: Function) => (emailId : any) => {
    dispatch(getCartCount(emailId));
};

const dispatchGetCartOrders = (dispatch: Function) => (emailId : any) => {
    dispatch(getCartOrders(emailId));
};

const dispatchGetDeleteCartOrder = (dispatch: Function) => (deleteDraft : any) => {
    dispatch(getDeleteCartOrder(deleteDraft));
};

const dispatchSetDeleteCartOrder = (dispatch: Function) => (deleteDraft : any) => {
    dispatch(setDeleteCartOrder(deleteDraft));
};

const OrderDispatch = {
    dispatchGetOrderById,
    dispatchGetCartCount,
    dispatchGetCartOrders,
    dispatchGetDeleteCartOrder,
    dispatchSetDeleteCartOrder
};

export default OrderDispatch